import { AxiosError } from "axios"

import { queryClient } from "~/backend/queryClient"
import {
  findOperationChainItemsQueryKey,
  useDeleteOperationChainItem,
} from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useDeleteOperationChainItemMutation = () =>
  useDeleteOperationChainItem({
    mutation: {
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries({
          queryKey: findOperationChainItemsQueryKey(
            variables.data.operationChainId
          ),
        })
        showSuccessNotification({
          title: "Success",
          message: "Operation chain item deleted",
        })
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          showAxiosError({
            notificationTitle: "Error",
            showNotification: true,
            error,
            notificationMessage:
              "Failed to delete operation chain item cause : " +
              error.response?.data,
          })
        }
      },
    },
  })
